module.exports = __webpack_public_path__ + "static/media/df.c868d6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/VehicleDepartmentsQuery/views/images/df.png
// module id = 1862
// module chunks = 174